import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, NavLink, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
  FormGroup,
  FormControlLabel,
  FormLabel,
  TextField,
  Card,
  Grid,
  Select,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';

export default function App() {
  const { state } = useLocation();
  const [saveORedit, setSaveOredit] = useState('');
  const navigate = useNavigate();
  const [nameValue, setNameValue] = useState('');
  const [block, setBlock] = useState([]);
  const [gp, setGp] = useState([]);
  const [blockValue, setBlockValue] = useState('');
  const [gpValue, setGpvalue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [mobileValue, setMobileValue] = useState('');
  const [usernameValue, setUsernameValue] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [districtValue, setDistrictValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isnameEmpty, setIsnameEmpty] = useState(false);
  const [isusernameEmpty, setIsusernameEmpty] = useState(false);
  const [ispasswordEmpty, setIspasswordEmpty] = useState(false);
  const [isconfirmpasswordEmpty, setIsconfirmpasswordEmpty] = useState(false);
  const [ismobileEmpty, setIsmobileEmpty] = useState(false);
  const [isblockEmpty, setIsblockEmpty] = useState(false);
  const [isgpEmpty, setIsgpEmpty] = useState(false);
  const [isdistrictEmpty, setdistrictEmpty] = useState(false);
  const [isnameError, setIsnameError] = useState(false);
  const [ismobileError, setIsmobileError] = useState(false);
  const [isusernameError, setIsusernameError] = useState(false);
  const [ispasswordError, setIspasswordError] = useState(false);
  const [isconfirmpasswordError, setIsconfirmpasswordError] = useState(false);
  const [isblockError, setIsblockError] = useState(false);
  const [isgpError, setIsgpError] = useState(false);
  const [isdistrictError, setIsdistrictError] = useState(false);
  const [error, setError] = useState(null);
  const fetchblock = () => {
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/get_block',
        {},
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setBlock(response.data.options);
        // console.log(response.data.options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchblock();
    console.log('prev', state);
    if (state !== null) {
      setNameValue(state.name);
      setMobileValue(state.mobile_no);
      setUsernameValue(state.username);
      setEmailValue(state.email);
      setBlockValue(state.block_code);
      setDistrictValue(state.district);
      gpValueForUpdate(state.block_code, state.gp_code);
      setSaveOredit(state.code);
      // setEmailValue(state.email);
    } else {
      // console.log(error);
      setSaveOredit('');
    }
  }, []);
  const createUser = (e) => {
    e.preventDefault();

    // if (nameValue.length === 0) {
    //   setIsnameEmpty(true);
    // }
    // if (mobileValue.length === 0) {
    //   setIsmobileEmpty(true);
    // }
    // if (usernameValue.length === 0) {
    //   setIsusernameEmpty(true);
    // }
    // if (passwordValue.length === 0) {
    //   setIspasswordEmpty(true);
    // }
    // if (confirmPassword.length === 0) {
    //   setIsconfirmpasswordEmpty(true);
    // }
    // if (blockValue.length === 0) {
    //   setIsblockEmpty(true);
    // }
    // if (gpValue.length === 0) {
    //   setIsgpEmpty(true);
    // }
    axios
      // .get("/api/Login",{
      //   email: login,
      //   password: password,
      // })
      .post('http://drdc.rtcsindia.co.in/api/user_entry', {
        // code: state.code,
        name: nameValue,
        username: usernameValue,
        password: passwordValue,
        mobile_no: mobileValue,
        confirm_password: confirmPassword,
        email: emailValue,
        block_code: blockValue,
        gp_code: gpValue,
        code: saveORedit,
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === 1) {
          toast('Successfully Save', {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            theme: 'light',
          });
          navigate('/dashboard/userlist');
          // localStorage.setItem('id_token', `Bearer ${response.data.token.token}`);
          // setError(null);
          // setIsLoading(false);
          // navigate('/dashboard', { replace: true });
        } else if (response.data.status === 2) {
          toast('Successfully Update', {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            theme: 'light',
          });
          navigate('/dashboard/userlist');
          // localStorage.setItem('id_token', `Bearer ${response.data.token.token}`);
          // setError(null);
          // setIsLoading(false);
          // navigate('/dashboard', { replace: true });
        } else if (response.data.status === 3) {
          toast('Username Already Exist', {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            theme: 'light',
          });
          // localStorage.setItem('id_token', `Bearer ${response.data.token.token}`);
          // setError(null);
          // setIsLoading(false);
          // navigate('/dashboard', { replace: true });
        } else if (response.data.status === 5) {
          console.log(response.data.error);
          toast(response.error, {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: 0,
            theme: 'light',
          });
        }
      })
      .catch((error) => {
        toast('Please Fill All The Data', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: 0,
          theme: 'light',
        });
      });
    // }, 1000);
    // } else {
    //   // dispatch({ type: "LOGIN_FAILURE" });
    //   setError(true);
    //   setIsLoading(false);
    //   toast('Invalid Username And password', {
    //     position: 'top-center',
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: false,
    //     draggable: true,
    //     progress: 0,
    //     theme: 'light',
    //   });
    // }
    // console.log('ooooooo');
    // console.log(nameValue, usernameValue, passwordValue, emailValue, mobileValue);
    // setError(false);
    // setIsLoading(true);
    // if (!!login && !!passwords) {
    // setTimeout(() => {
  };
  const gpValueForUpdate = (block, gp) => {
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/get_gp',
        { block_code: block },
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        // console.log('edittttt', response.data.options);

        setGp(response.data.options);
        // console.log(gp);
        // setGp(block);
        // console.log(response.data.options);
      })
      .catch((err) => {
        console.log(err);
      });
    setGpvalue(gp);
  };
  const validatoralphabet = /^[a-zA-Z\s]*$/;
  const validatorusernamealphabet = /^[@A-Za-z0-9\s]*$/;
  const validatornumber = /^[0-9]*$/;
  const changeName = (e) => {
    setIsnameEmpty(false);

    if (!validatoralphabet.test(e.target.value)) {
      setIsnameError(true);
      // setIsname(true);
    } else {
      setIsnameError(false);
    }
    setNameValue(e.target.value);
  };
  const changeMobileNo = (e) => {
    // ;
    setIsmobileEmpty(false);
    // console.log(e.target.value);

    if (!validatornumber.test(e.target.value)) {
      // setIsmobile(true);
      setIsmobileError(true);
    } else {
      setIsmobileError(false);
    }
    setMobileValue(e.target.value);
  };
  const changeUsername = (e) => {
    setIsusernameEmpty(false);

    // console.log(e.target.value);
    if (!validatorusernamealphabet.test(e.target.value)) {
      setIsusernameError(true);
    } else {
      setIsusernameError(false);
    }
    setUsernameValue(e.target.value);
  };
  const changePassword = (e) => {
    setIspasswordEmpty(false);

    // console.log(e.target.value);
    if (!validatorusernamealphabet.test(e.target.value)) {
      setIspasswordError(true);
    } else {
      setIspasswordError(false);
    }
    setPasswordValue(e.target.value);
  };
  const changeEmail = (e) => {
    // console.log(e.target.value);
    setEmailValue(e.target.value);
  };
  const changedistrict = (e) => {
    // console.log(e.target.value);
    setDistrictValue(e.target.value);
  };
  const changeConfirmPassword = (e) => {
    setIsconfirmpasswordEmpty(false);

    // console.log(e.target.value);
    if (!validatorusernamealphabet.test(e.target.value)) {
      setIsconfirmpasswordError(true);
    } else {
      setIsconfirmpasswordError(false);
    }
    setConfirmPassword(e.target.value);
  };
  const changeblock = (e) => {
    // console.log(e.target.value);
    setIsblockEmpty(false);
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/get_gp',
        { block_code: e.target.value },
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setGp(response.data.options);

        // console.log(response.data.options);
      })
      .catch((err) => {
        console.log(err);
      });

    setBlockValue(e.target.value);
  };
  const changegp = (e) => {
    setIsgpEmpty(false);

    // console.log(e.target.value);
    setGpvalue(e.target.value);
  };
  function MyFormHelperText() {
    const { focused } = useFormControl() || {};

    const helperText = React.useMemo(() => {
      if (focused) {
        return 'This field is being focused';
      }

      return 'Helper text';
    }, [focused]);

    return <FormHelperText>{helperText}</FormHelperText>;
  }
  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Grid container spacing={4} className="user-form" style={{ padding: '2%' }}>
          <Grid item xs={2}>
            <Typography variant="h4" gutterBottom>
              Create User
            </Typography>
          </Grid>
          <Grid item xs={8} />
          <Grid item xs={2}>
            <NavLink to="/dashboard/userlist" style={{ textDecoration: 'none' }}>
              <Button variant="contained">User List</Button>
            </NavLink>
          </Grid>
        </Grid>
      </Stack>
      <Card>
        <Scrollbar>
          <div />
        </Scrollbar>
        <form className="user">
          <Grid container spacing={4} className="user-form" style={{ padding: '2%' }}>
            <Grid item xs={6}>
              <FormLabel id="outlined-basic" variant="outlined">
                Name
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="name"
                id="outlined-basic"
                value={nameValue}
                variant="outlined"
                // helperText="Name Field Is required"
                required
                onChange={changeName}
              />
              {isnameError ? <span style={{ color: 'red' }}>Only albhabet allowed</span> : ''}
              <br />
              {isnameEmpty ? <span style={{ color: 'red' }}>This Field Is Required</span> : ''}
            </Grid>

            <Grid item xs={6}>
              <FormLabel id="outlined-basic" variant="outlined">
                Mobile No
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                pattern="[0-9]*"
                name="mobile"
                value={mobileValue}
                variant="outlined"
                inputProps={{
                  maxLength: 10,
                }}
                required
                onChange={changeMobileNo}
              />
              {ismobileError ? <span style={{ color: 'red' }}>Only Number allowed</span> : ''}
              <br />
              {ismobileEmpty ? <span style={{ color: 'red' }}>This Field Is Required</span> : ''}
            </Grid>
            <Grid item xs={6}>
              <FormLabel id="outlined-basic" variant="outlined">
                Username
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="username"
                id="outlined-basic"
                variant="outlined"
                value={usernameValue}
                required
                onChange={changeUsername}
              />
              {isusernameError ? <span style={{ color: 'red' }}>Only Alphabet Number And @ Allowed</span> : ''}
              <br />
              {isusernameEmpty ? <span style={{ color: 'red' }}>This Field Is Required</span> : ''}
            </Grid>
            {state !== null ? (
              <div />
            ) : (
              <Grid item xs={6}>
                <FormLabel id="outlined-basic" variant="outlined">
                  Password
                </FormLabel>
              </Grid>
            )}
            {state !== null ? (
              <div />
            ) : (
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="password"
                  id="outlined-basic"
                  variant="outlined"
                  required
                  onChange={changePassword}
                />
                {ispasswordError ? <span style={{ color: 'red' }}>Only Alphabet Number And @ Allowed</span> : ''}
                <br />
                {ispasswordEmpty ? <span style={{ color: 'red' }}>This Field Is Required</span> : ''}
              </Grid>
            )}

            {state !== null ? (
              <div />
            ) : (
              <Grid item xs={6}>
                <FormLabel id="outlined-basic" variant="outlined">
                  Confirm Password
                </FormLabel>
              </Grid>
            )}
            {state !== null ? (
              <div />
            ) : (
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="confirmpassword"
                  id="outlined-basic"
                  variant="outlined"
                  required
                  onChange={changeConfirmPassword}
                />
                {isconfirmpasswordError ? <span style={{ color: 'red' }}>Only Alphabet Number And @ Allowed</span> : ''}
                <br />
                {isconfirmpasswordEmpty ? <span style={{ color: 'red' }}>This Field Is Required</span> : ''}
              </Grid>
            )}
            {/* <Grid item xs={6}>
              <FormLabel id="outlined-basic" variant="outlined">
                District
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <select
                className="select-box"
                label="demo-simple-select-label"
                id="demo-simple-select"
                onChange={changedistrict}
              >
                <option value="">select</option>
                <option selected value="Birbhum">
                  Birbhum
                </option>
              </select>
            </Grid> */}
            <Grid item xs={6}>
              <FormLabel id="outlined-basic" variant="outlined">
                Block
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <select
                className="select-box"
                label="demo-simple-select-label"
                id="demo-simple-select"
                onChange={changeblock}
              >
                <option value="">select</option>
                {block.map((key) =>
                  key.code === blockValue ? (
                    <option selected name="block_code" key="" value={key.code}>
                      {key.block_name}
                    </option>
                  ) : (
                    <option name="block_code" key="" value={key.code}>
                      {key.block_name}
                    </option>
                  )
                )}
              </select>
              {isblockEmpty ? <span style={{ color: 'red' }}>This Field Is Required</span> : ''}
            </Grid>
            <Grid item xs={6}>
              <FormLabel id="outlined-basic" variant="outlined">
                Gp
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <select
                label="demo-simple-select-label"
                className="select-box"
                id="demo-simple-select"
                onChange={changegp}
              >
                <option value="">select</option>
                {gp.map((key) =>
                  key.code === gpValue ? (
                    <option selected name="gp_code" key="" value={key.code}>
                      {key.gp_name}
                    </option>
                  ) : (
                    <option name="gp_code" key="" value={key.code}>
                      {key.gp_name}
                    </option>
                  )
                )}
              </select>
              {isgpEmpty ? <span style={{ color: 'red' }}>This Field Is Required</span> : ''}
            </Grid>

            <Grid item xs={6}>
              <FormLabel fullWidth id="outlined-basic" variant="outlined">
                Email Id
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                name="email"
                id="outlined-basic"
                variant="outlined"
                value={emailValue}
                required
                onChange={changeEmail}
              />
            </Grid>
            <Grid item xs={5} />
            <Grid item xs={4}>
              <Button className="button-user" onClick={createUser}>
                Save
                {/* "name" => "Oly Rajak" "username" => "olyrajak" "password" => "olyraja3k@gmail.com" "email" => "olyrajak"
                "mobile_no" => "9898900955" "confirm_password" => "olyrajak" Save */}
              </Button>
            </Grid>
            <Grid item xs={4} />
          </Grid>
        </form>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Card>
    </Container>
  );
}
